export const REGION = 'Region';
export const BILLING_COUNTRY = 'Billing Country (Amex Entity)';
export const BILLING_CURRENCY = 'Billing Currency';
export const SUPPLIER_REGISTERED_NAME = 'Supplier Registered Name';
export const SUPPLIER_REGISTERED_LOCAL_NAME = 'Supplier Registered Name in Local Language';
export const SUPPLIER_REGISTERED_ADDRESS_LINE1 = 'Supplier Registered Address Line 1';
export const SUPPLIER_REGISTERED_ADDRESS_LINE2 = 'Supplier Registered Address Line 2';
export const SUPPLIER_REGISTERED_LOCAL_ADDRESS_LINE1 =
  'Supplier Registered Address in Local Language Line 1';
export const SUPPLIER_REGISTERED_LOCAL_ADDRESS_LINE2 =
  'Supplier Registered Address in Local Language Line 2';
export const CITY = 'City';
export const STATE_PROVINCE = 'State/Province';
export const POSTAL_CODE = 'Postal Code';
export const COUNTRY = 'Country';
export const PAYEE_NAME = 'Payee Name (If different from Registered Name)';
export const PAYEE_LOCAL_NAME =
  'Supplier Payee Name in Local Language';
export const PAYEE_ADDRESS_LINE1 = 'Payee Address Line1 (If different from Address Line1)';
export const PAYEE_ADDRESS_LINE2 = 'Payee Address Line2 (If different from Address Line2)';
export const PAYEE_ADDRESS_LOCAL_LINE1 = 'Supplier Payee Address in Local Language Line1';
export const PAYEE_ADDRESS_LOCAL_LINE2 = 'Supplier Payee Address in Local Language Line2';
export const PAYEE_CITY = 'Payee City';
export const PAYEE_STATEORPROVINCE = 'Payee State/Province';
export const PAYEE_POSTAL_CODE = 'Payee Postal Code';
export const PAYEE_COUNTRY = 'Payee Country';
export const COMPANY_FINANCE_DECISION = "I am my company's key financial decision maker.";
export const SUPPLIER_CONTACT_PERSON = "Supplier's Contact Person";
export const SUPPLIER_EMAIL_ADDRESS = "Supplier's Email Address";
export const SUPPLIER_PHONE_NUMBER = "Supplier's Phone Number: (+)";
export const SUPPLIER_FAX_NUMBER = "Supplier's Fax Number: (+)";
export const IS_MSME = 'Is Supplier registered under Micro, Small & Medium Enterprises (MSME) Act?';
export const PAN = 'Permanent Account Number (PAN) ';
export const SERVICE_TAX_NO = 'Service Tax #';
export const REGISTERED_STATE = 'States where supplier has registered for sales & use tax';
export const REGISTERED_STATE_NO = 'Registration Number for each State';
export const ABN = 'ABN #';
export const NIF = 'NIF code(Tax ID)';
export const GST_NO = 'GST No/Tax ID';
export const TIN = 'TIN #';
export const UEN = 'UEN #';
export const BUSINESS_REG_CERT_NO = 'Business Reg.Certificate no';
export const AUDIT_FIRM = 'Audit Firm';
export const PAYMENT_METHOD = 'Payment Method';
export const REMITTANCE_EMAIL_ADDRESS = 'Remittance Email Address';
export const PAYMENT_TERMS = 'Payment Terms';
export const SERVICE_ESTABLISHMENT = 'Service Establishment # (For CPC payment method only)';
export const BANK_NAME = 'Bank Name';
export const BIC = 'BIC/Swift Code';
export const BRANCH_NAME = 'Branch Name';
export const BRANCH_CODE = 'Branch Code/IFSC Code';
export const ACCOUNT_NUMBER = 'Account Number';
export const BANK_CODE = 'Bank Code/IBAN Code';
export const ACCOUNT_TYPE = 'Account Type';
export const ABA = 'ABA/Routing No/BSB/Sort Code';
export const INTERMEDIATE_BANK_NAME = 'Intermediate Bank Name (If Applicable)';
export const INTERMEDIATE_BANK_BIC = 'Intermediate Bank BIC/Swift Code (If Applicable)';
export const INTERMEDIATE_BANK_BRANCH_NAME = 'Intermediate Bank Branch Name (If Applicable)';
export const INTERMEDIATE_BANK_BRANCH_CODE =
  'Intermediate Bank Branch Code/IFSC Code (If Applicable)';
export const INTERMEDIATE_BANK_ACCOUNT_NUMBER = 'Intermediate Bank Account Number (If Applicable)';
export const INTERMEDIATE_BANK_ABA =
  'Intermediate Bank ABA/Routing No./BSB/Account Type (if applicable)';
export const SUPPLIER_JAPAN_BANK_NAME = 'Japan Located Bank Name(Please use Katakana script) :';
export const SUPPLIER_JAPAN_BRANCH_NAME = 'Japan Located Branch Name(Please use Katakana script) :';
export const BANK_GIRO_NUMBER = 'Bank Giro/Plus Giro';
export const AMEX_CONTACT_NAME = 'Amex contact name ';
export const AMEX_CONTACT_EMAIL = 'Amex contact email ';
export const AMEX_CONTACT_TELEPHONE_NUMBER = 'Amex contact telephone number: (+) ';
export const AMEX_CONTACT_BUSINESS_UNIT = 'Amex contact Business Unit';
export const SUPPLIER_CONTACT_INFORMATION = 'Supplier Contact Information';
export const SUPPLIER_INFORMATION = 'Supplier Information';
export const SUPPLIER_BANKING_INFORMATION = 'Supplier Banking Information';
export const AMERICAN_EXPRESS_CONTACT_INFORMATION = 'American Express Contact Information';
export const REVIEW = 'Review';
export const ATTACHED_FILES = 'List Of Attached File(s)';
export const ATTACH_DOC_INFO =
  "Upload your documents you're sending to your American Express Contact." +
  ' Please note, each file cannot exceed 3MBs.';
export const GST_TEXT_INFO =
  'If Supplier is Tax Exempt please attach tax' +
  ' exemption supporting document in the attachment section of the form and' +
  ' in the Tax Field you can put NA.';
export const BANK_ACCOUNT_NUMBER_TEXT_INFO =
  'Any of the following documents can be attached:' +
  '- Bank letter head having account holder name and complete banking details on it.' +
  '- Bank statement having account holder name and account number (transactions can be masked)' +
  '- Copy of a cancelled check';
export const EMAIL_ADDRESS_PAYMENT_ADVICE =
  'Provide the email address where the payment advice needs to be sent.';
export const REQUIRED_FIELDS_SUPPLIER_INPUT_TEXT =
  'Please input your supplier information. *Required Fields';
export const SERVICE_ESTABLISHMENT_INFO =
  'Provide the 10-digit service establishment number assigned by American Express' +
  " to uniquely identify the supplier in case the payment method is selected above as 'CPC'.";
export const GST_TAX_VERBIAGE_INFO =
  'You are required to attach an official tax Id proof document on' +
  ' the next page in pdf format.';
export const ACCOUNT_NUMBER_VERBIAGE_INFO =
  'You are required to attach bank details document, please refer to "i" button to' +
  ' check the acceptable documents.';
export const PAYMENT_TERMS_VERBIAGE_INFO =
  'By default the supplier will be setup on the standard payment term as applicable to the market. ' +
  "In case you want to select a non-standard payment term, then select the option as 'Other' and provide the detail. " +
  'Please note that additional approval from category manager will be required to setup the supplier on non-standard payment term.';
export const REQUIRED_FIELD_VALIDATOR = 'required';
export const EMAIL_FIELD_VALIDATOR = 'email';
export const AMEX_EMAIL_FIELD_VALIDATOR = 'amexEmail';
export const PHONE_FIELD_VALIDATOR = 'phone'
export const DASH_ALPHANUMERIC_REGEX_VALIDATOR = 'dashAlphanumeric';
export const DASH_ALPHANUMERIC_REGEX_MESSAGE = 'Only dash, alphabets and numbers are allowed';
export const CHECKBOX_ERROR_MESSAGE ='This checkbox is required';
export const SIREN_NUMBER = 'SIREN Number';
export const SIREN_VERBIAGE_INFO =
  'Please enter company’s SIREN number, also attach an official tax Id proof document' +
  ' on the next page in pdf format.';
export const SIRET_NUMBER = 'SIRET Number';
export const SIRET_VERBIAGE_INFO =
  'Please enter company’s SIRET number, also attach an official tax Id proof document' +
  ' on the next page in pdf format.';
export const TAX_REPRESENTATIVE = 'Tax Representative';
export const TAX_REPRESENTATIVE_INFO = 'Please confirm, if this cross-border supplier has any tax representative in France';
export const TAX_REPRESENTATIVE_VAT_ID = 'Tax Representative VAT ID';
export const TAX_REPRESENTATIVE_VAT_ID_INFO = 'Please input VAT ID/TAX ID of seller\'s tax representative in France.';